import { useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const useSessionTimeout = (timeoutMinutes = 30) => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];

  const logout = useCallback(() => {

    localStorage.removeItem('admin_token');
    localStorage.removeItem('roles');
    

    toast.info('Your session has expired. Please log in again.', {
      position: 'top-right',
      autoClose: 5000,
    });
    
  
    navigate('/ng-admin');
  }, [navigate]);

  const resetTimer = useCallback(() => {
  
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      logout();
    }, timeoutMinutes * 60 * 1000);
  }, [timeoutMinutes, logout]);

  useEffect(() => {
    const handleActivity = () => {
      resetTimer();
    };

    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    resetTimer();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [resetTimer, events]);

  return { resetTimer };
};

export default useSessionTimeout;
